import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useAppRoutes } from '@root/features/routing'
import { WalletDepositDrawer } from '@root/features/wallet/deposit/ui/mobile'
import {
  BankIcon,
  SolidButton,
  SwapIcon,
  WalletIcon,
} from '@root/shared/ui-kit'

import type { WalletModel } from '@root/entities/wallet/atoms'

type Props = {
  wallet: WalletModel
}
export const WalletActions: React.FC<Props> = ({ wallet }) => {
  const { t } = useTranslation()
  const [depositOpened, setDepositOpened] = useState(false)
  const { navigateToWalletSwap, navigateToWalletTransfer } = useAppRoutes()

  return (
    <Root>
      <SolidButton
        type="button"
        onClick={() => {
          navigateToWalletSwap(wallet.id)
        }}
        icon={SwapIcon}
      >
        {t('trading.swap')}
      </SolidButton>
      <SolidButton
        type="button"
        icon={WalletIcon}
        onClick={() => {
          setDepositOpened(true)
        }}
      >
        {t('deposit')}
      </SolidButton>
      <SolidButton
        type="button"
        onClick={() => {
          navigateToWalletTransfer(wallet.id)
        }}
        icon={BankIcon}
      >
        {t('common.withdraw')}
      </SolidButton>
      <WalletDepositDrawer
        open={depositOpened}
        onOpenChange={setDepositOpened}
        wallet={wallet}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: 4px;

  height: 56px;
`
